import React, { useCallback, useMemo } from 'react';
import AutocompleteSelect from 'UI/components/molecules/AutocompleteSelect';

import { DEFAULT_INTERVAL_MINUTES } from './TimeSelect.constants';
import { generateTimeOptions, getSelectedOption } from './TimeSelect.utils';

export const TimeSelect = ({
  disabled = false,
  error = false,
  errorText = '',
  intervalMinutes = DEFAULT_INTERVAL_MINUTES,
  name,
  onChange,
  placeholder,
  value = null,
  ...rest
}) => {
  const options = useMemo(() => {
    try {
      return generateTimeOptions(intervalMinutes);
    } catch (err) {
      return generateTimeOptions(DEFAULT_INTERVAL_MINUTES);
    }
  }, [intervalMinutes]);

  const selectedValue = useMemo(() => getSelectedOption(options, value), [options, value]);

  const handleSelect = useCallback(
    (_, option) => {
      onChange && onChange(option ? option.id : null);
    },
    [onChange]
  );

  return (
    <AutocompleteSelect
      defaultOptions={options}
      disabled={disabled}
      error={error}
      errorText={errorText}
      name={name}
      onSelect={handleSelect}
      placeholder={placeholder}
      selectedValue={selectedValue}
      {...rest}
    />
  );
};
